import React, { useEffect, useState } from "react";
import Button from "../../../../components/Button/Button";
import Card from "../../../../components/Card/Card";
import DeleteButton from "../../../../components/DeleteButton/DeleteButton";
import Input from "../../../../components/Input/Input";
import List from "../../../../components/List/List";
import ModalComponent from "../../../../components/Modal/ModalComponent";
import Select from "../../../../components/Select/Select";
import { useListManager } from "../../../../contexts/list.manager";
import CondoUserService from "../../../../services/CondoUserService";
import "../TabsCondoUsers.css";
import "./TabCondoUsersUnits.css";
import { v4 as uuidv4 } from 'uuid';
import { LicenseUnitSelector } from "../../../../components/LicenseUnitSelector/LicenseUnitSelector";
import { useUserStore } from "../../../../contexts/userStore";
import ToggleButton from "../../../../components/ToggleButton/ToggleButton";
import ListUnits from "../../../Units/ListUnits/ListUnits";
import { MdApartment, MdDelete, MdEdit } from "react-icons/md";
import { NotificationManager } from "react-notifications";
import { CondoUserReaders } from "./CondoUserReaders";
import { BiCollapseAlt } from "react-icons/bi";
import { DynamicIcon } from "../../../../components/DynamicIcon/DynamicIcon";
import ListTags from "../../../Tags/ListTags/ListTags";
import ListClientTags from "../../../Tags/ListClientTags/ListClientTags";
import { DynamicTagFields } from "../../../../components/DynamicTagFields/DynamicTagFields";
import { UnitResponsibility, UnitResponsibilityText, UnitResponsibleRelation, UnitResponsibleRelationText } from "../../../../constants/unit";
import { AnimatedTabbar, AnimatedTabbarItem } from "../../../../components/AnimatedTabbar/AnimatedTabbar";
import { LuSettings } from "react-icons/lu";
import { BsFillPersonLinesFill } from "react-icons/bs";
import { TbBuildingCommunity } from "react-icons/tb";
import { Home, IdCardLanyard } from "lucide-react";
import { useTranslation } from "react-i18next";
import { wait } from "../../../../utils/timer";

const TabCondoUserUnits = (props) => {
   const [condoUserLicenses, setCondoUserLicenses] = useState([]);
   const [condoUserTags, setCondoUserTags] = useState([]);
   const [showModal, setShowModal] = useState(false);
   const { lineSelected, setLineSelected, closeForm } = useListManager();
   const { condominiums, clientLicenses } = useUserStore();
   const [activeTab, setActiveTab] = useState('perfil'); // perfil, unidade e avançado

   const [license, setLicense] = useState(null);
   const [ownerUnit, setOwnerUnit] = useState(null);
   const [profileTag, setProfileTag] = useState(null);
   const [metadata, setMetadata] = useState([]);
   const [isAdmin, setIsAdmin] = useState(false);
   const [enrollmentNumber, setEnrollmentNumber] = useState("");
   const [unit, setUnit] = useState(null);
   const [mode, setMode] = useState("");
   const [responsibility, setResponsibility] = useState("0");
   const [relation, setRelation] = useState("0");
   const [otherRelation, setOtherRelation] = useState("");
   const [customInput1, setCustomInput1] = useState("");
   const [credits, setCredits] = useState(null);
   const [disabledCredits, setDisabledCredits] = useState(false);
   const [authorizerUnits, setAuthorizerUnits] = useState([]);
   const [filters, setFilters] = useState([""]);
   const [modalUnitIsOpen, setModalUnitIsOpen] = useState(false);
   const [modalAuthorizerUnitIsOpen, setModalAuthorizerUnitIsOpen] = useState(false);
   const [modalProfileIsOpen, setModalProfileIsOpen] = useState(false);
   const [searchProfileTag, setSearchProfileTag] = useState("");
   const [filtersProfileTag, setFiltersProfileTag] = useState([""]);
   const { t } = useTranslation();

   const getCondoUserLicenses = async (condoUser) => {
      props.setLicensesIsLoading(true);
      if (!condoUser?.id) return;
      const response = await CondoUserService.listCondoUserLicenses(
         condoUser?.id,
      );
      const data = response.data.map(l => ({
         ...l,
         readers: null,
         authorizerUnits: l.authorizerUnits?.map(u => ({
            uuid: u.uuid || u,
            name: u.name || u,
            id: u.id || u,
         })) || [],
      }));
      setCondoUserLicenses(data);
      props.handleChangeLicenses?.(data);
      props.setLicensesIsLoading(false);
   };

   const getCondoUserTags = async (condoUser) => {
      if (!condoUser?.id) return;
      const response = await CondoUserService.listCondoUserTags(
         condoUser?.id,
      );
      const data = response.data;
      setCondoUserTags(data);
      console.log('tags: ', data);
      props.handleChangeTags?.(data);
   };

   function updateUserReaders(userReaders, ownerUnitId) {
      const data = condoUserLicenses.map(l => ({
         ...l,
         readers: ownerUnitId === l.ownerUnit.id ? userReaders.filter(r => r.reader.licenseId === l.license.id) : l.readers
      }));
      setCondoUserLicenses(data);
      props.handleChangeLicenses?.(data);
   }

   useEffect(() => {
      getCondoUserLicenses(props.condoUser);
      getCondoUserTags(props.condoUser);
   }, [props.condoUser]);

   async function saveNewLicenses() {
      let payload = {
         uuid: uuidv4(),
         license: license,
         isAdmin: isAdmin,
         enrollment_number: enrollmentNumber,
         ownerUnit: ownerUnit,
         unit: unit,
         responsibility: responsibility,
         relation: relation,
         otherRelation: otherRelation,
         authorizerUnits: authorizerUnits,
         credits: credits,
         disabledCredits: disabledCredits,
         status: 'draft',
      };

      if (condoUserLicenses.find(l => l.license.id === payload.license.id)) {
         NotificationManager.error(
            "",
            "Licença já adicionada",
            5000,
         );
         return;
      }

      setCondoUserLicenses((prevLicenses) => [...prevLicenses, payload]);
      const newCondoUserLicenses = [...condoUserLicenses, payload];
      props.handleChangeLicenses(newCondoUserLicenses);
   }

   async function saveNewTags() {
      let payload = {
         uuid: uuidv4(),
         licenseId: license.id,
         tagId: profileTag.id,
         ownerUnitId: ownerUnit.id,
         metadata: metadata,
         status: 'draft',
      };

      if (condoUserTags.find(t => t.tagId === payload.tagId && t.ownerUnitId === payload.ownerUnitId)) {
         NotificationManager.error(
            "",
            "Perfil já adicionado",
            5000,
         );
         return;
      }

      setCondoUserTags((prevTags) => [...prevTags, payload]);
      const newCondoUserTags = [...condoUserTags, payload];
      props.handleChangeTags(newCondoUserTags);
   }

   async function editLicenses() {
      const indexToUpdate = condoUserLicenses.findIndex(
         (item) => item.license.id === license.id,
      );
      if (indexToUpdate !== -1) {
         const updatedPayload = {
            ...condoUserLicenses[indexToUpdate],
            license: license,
            isAdmin: isAdmin,
            enrollment_number: enrollmentNumber,
            ownerUnit: ownerUnit,
            unit: unit,
            responsibility: responsibility,
            relation: relation,
            otherRelation: otherRelation,
            authorizerUnits: authorizerUnits,
            credits: credits,
            disabledCredits: disabledCredits,
            status: 'draft',
         };

         if (condoUserLicenses.find(l => l.license.id === license.id && l.uuid !== updatedPayload.uuid)) {
            NotificationManager.error(
               "",
               "Licença já adicionada",
               5000,
            );
            return;
         }

         const updatedCondoUserLicenses = condoUserLicenses.map(
            (item, index) => {
               if (index === indexToUpdate) {
                  return updatedPayload;
               }
               return item;
            },
         );
         setCondoUserLicenses(updatedCondoUserLicenses);
         props.handleChangeLicenses(updatedCondoUserLicenses);
      }
   }

   async function editTags() {
      const indexToUpdate = condoUserTags.findIndex(
         (item) => item.tagId === profileTag.id,
      );
      if (indexToUpdate !== -1) {
         const updatedPayload = {
            ...condoUserTags[indexToUpdate],
            licenseId: license.id,
            tagId: profileTag.id,
            ownerUnitId: ownerUnit.id,
            metadata: metadata,
            status: 'draft',
         };

         if (condoUserTags.find(t => t.tagId === profileTag.id && t.ownerUnitId === ownerUnit.id && t.licenseId === license.id && t.uuid !== updatedPayload.uuid)) {
            NotificationManager.error(
               "",
               "Perfil já adicionado",
               5000,
            );
            return;
         }

         const updatedCondoUserTags = condoUserTags.map(
            (item, index) => {
               if (index === indexToUpdate) {
                  return updatedPayload;
               }
               return item;
            },
         );
         setCondoUserTags(updatedCondoUserTags);
         props.handleChangeTags(updatedCondoUserTags);
      }
   }

   async function removeLicenses(row) {
      const indexToRemove = condoUserLicenses.findIndex(
         (item) => item.licenseId === row.licenseId,
      );
      if (indexToRemove !== -1) {
         const updatedCondoUserLicenses = [
            ...condoUserLicenses.slice(0, indexToRemove),
            ...condoUserLicenses.slice(indexToRemove + 1),
         ];
         setCondoUserLicenses(updatedCondoUserLicenses);
         props.handleChangeLicenses(updatedCondoUserLicenses);
         closeForm();
      }
   }

   async function removeTag(row) {
      const indexToRemove = condoUserTags.findIndex(
         (item) => item.tagId === row.tagId,
      );
      if (indexToRemove !== -1) {
         const updatedCondoUserTags = [
            ...condoUserTags.slice(0, indexToRemove),
            ...condoUserTags.slice(indexToRemove + 1),
         ];
         setCondoUserTags(updatedCondoUserTags);
         props.handleChangeTags(updatedCondoUserTags);
      }
   }

   const handleClickModalButton = (action) => {
      if (action === "confirm") {
         if (mode === "add") saveNewLicenses();
         if (mode === "edit") editLicenses();

         if (profileTag) {
            if (condoUserTags.find(t => Number(t.tagId) === Number(profileTag.id) && Number(t.ownerUnitId) === Number(ownerUnit.id))) {
               editTags();
            } else {
               saveNewTags();
            }
         }
      }
      setLicense(null);
      setIsAdmin(false);
      setEnrollmentNumber("");
      setOwnerUnit(null);
      setUnit(null);
      setResponsibility("0");
      setRelation("0");
      setOtherRelation("");
      setShowModal(false);
      setProfileTag(null);
      setMetadata([]);
      setCredits(null);
      setDisabledCredits(false);
      setAuthorizerUnits([]);
      closeForm();
   };

   const handleClickAdd = () => {
      setMode("add");
      setShowModal(true);
   };

   const handleClickEdit = (row) => {
      const item = row ?? lineSelected;
      if (!item) return;
      setMode("edit");
      setLicense(item.license);
      setIsAdmin(item.isAdmin);
      setEnrollmentNumber(item.enrollment_number);
      setOwnerUnit(item.ownerUnit);
      setUnit(parseUnitData(item.unit));
      setResponsibility(item.responsibility);
      setRelation(item.relation);
      setOtherRelation(item.otherRelation);
      setCredits(item.credits);
      setDisabledCredits(item.disabledCredits);
      setAuthorizerUnits(item.authorizerUnits ?? []);
      setShowModal(true);

      const condoUserTag = condoUserTags.find(t => t.ownerUnitId === item.ownerUnitId);
      setProfileTag(condoUserTag.tag ? {
         ...condoUserTag.tag,
         id: Number(condoUserTag.tag.id)
      } : null);
      setMetadata(condoUserTag?.metadata)
   };

   function parseUnitData(unitdata) {
      if (!unitdata) return null;
      let payload = unitdata;
      payload.id_unit = unitdata?.id;
      payload.name = unitdata.name;
      payload.parkingLotBusy = unitdata.metadata?.find(metadataItem => metadataItem.name === 'parkingLotBusy')?.value;
      payload.parkingLotQuantity = unitdata.metadata?.find(metadataItem => metadataItem.name === 'parkingLotQuantity')?.value;
      return payload;
   }

   function parseTagData(tagData) {
      let payload = tagData;
      return payload;
   }

   async function saveCondoUserUnit() {
      if (!lineSelected) return;

      const payload = parseUnitData(lineSelected);
      setUnit(payload);
   }

   async function saveAuthorizerUnit() {
      if (!lineSelected) return;

      const payload = {
         id: lineSelected.id,
         name: lineSelected.name,
         uuid: lineSelected.externalId,
      };
      setAuthorizerUnits(prevUnits =>
         prevUnits?.find(unit => unit.id === payload.id)
            ? prevUnits
            : [...prevUnits, payload]
      );
   }

   async function saveProfileTag() {
      if (!lineSelected) return;
      if (profileTag?.id === lineSelected.id) return;

      const payload = parseTagData(lineSelected);
      setProfileTag(payload);
   }

   const handleClickRemove = (row) => {
      const item = row ?? lineSelected;
      if (!item) return;
      removeLicenses(item);
   };

   async function handleConfirm() {
      saveCondoUserUnit();
      setModalUnitIsOpen(false);
   }

   async function handleCancel() {
      setModalUnitIsOpen(false);
   }

   async function handleConfirmAuthorizerUnit() {
      saveAuthorizerUnit();
      setModalAuthorizerUnitIsOpen(false);
   }

   async function handleCancelAuthorizerUnit() {
      setModalAuthorizerUnitIsOpen(false);
   }

   function handleUnlinkUnit() {
      setUnit(null);
   }

   function handleUnlinkProfile() {
      removeTag(condoUserTags.find(t => Number(t.tagId) === Number(profileTag.id) && Number(t.ownerUnitId) === Number(ownerUnit.id)));
      setMetadata([]);
      setProfileTag(null);
   }

   function handleUnlinkAuthorizerUnit(unit) {
      setAuthorizerUnits(prevUnits =>
         prevUnits?.filter(authorizerUnit => authorizerUnit.id !== unit.id)
      );
   }

   async function handleConfirmProfile() {
      saveProfileTag();
      setModalProfileIsOpen(false);
   }

   async function handleCancelProfile() {
      setModalProfileIsOpen(false);
   }

   const unitTag = unit?.tags?.find(t => t.linkableToUser && t.sendToDevices);

   return (
      <div
         style={{ display: props.show ? "flex" : "none", alignItems: "center", flexDirection: "column" }}
      >
         <div className="tab-condo-users-buttons-container w-full">
            <div className="tab-condo-users-buttons">
               <Button
                  action="add"
                  className="tab-condo-users-add button-white"
                  label="Adicionar licença"
                  onClick={handleClickAdd}
                  disabled={props.licenseIsLoading}
               />
            </div>
         </div>
         <div className="list-visibility list-condo-users-units w-full">
            <List
               isLoading={props.licenseIsLoading}
               selectable={false}
               listEntityName={'condoUsers'}
               collumsObjIndex={[
                  { collumnLabel: "Licença", index: "ownerUnit.name", type: "text" },
                  { collumnLabel: "Administrador", index: "isAdmin", custom: ({ row }) => row.isAdmin ? "Sim" : "Não" },
                  { collumnLabel: "Matrícula", index: "enrollment_number", custom: ({ row }) => row.enrollment_number ? row.enrollment_number : <span style={{ opacity: 0.36 }}>Não consta</span> },
                  { collumnLabel: "Unidade", index: "unit.name", custom: ({ row }) => row.unit?.name ? row.unit.name : <span style={{ opacity: 0.36 }}>Não consta</span> },
                  { collumnLabel: "Status", index: "status", showLabel: true, type: "sync-status" },
                  {
                     collumnLabel: "Ações", type: "actions", custom: ({ row }) => {
                        return (
                           <div className="flex justify-end gap-4">
                              <button type="button" className={`cursor-pointer hover:opacity-70 duration-100`} onClick={e => {
                                 handleClickEdit(row);
                              }}>
                                 <MdEdit size={18} />
                              </button>
                              <DeleteButton
                                 className="button-white tab-condo-users-buttons-visibility"
                                 handleDelete={() => handleClickRemove(row)}
                                 simple
                              />
                           </div>
                        );
                     }
                  },
               ]}
               expandableContent={({ row, toggleExpanded }) => {
                  return (
                     <CondoUserReaders
                        condoUser={props.condoUser}
                        condoUserLicense={row}
                        unitId={row.ownerUnit.id}
                        toggleExpanded={toggleExpanded}
                        updateUserReaders={updateUserReaders}
                     />
                  );
               }}
               data={condoUserLicenses.map(l => ({
                  ...l,
                  id: props.condoUser?.id || uuidv4(),
                  _expandableId_: `${l.ownerUnit.id}`,
                  _expandable_: true,
                  _preload_expandable_: true,
                  _expandableLabel_: "Leitoras"
               }))}
            />
         </div>
         <div
            className="card-visibility"
            style={{ width: "100%", maxWidth: "500px" }}
         >
            {condoUserLicenses?.length > 0 ? (
               condoUserLicenses.map((license, index) => (
                  <Card
                     key={index}
                     data={license}
                     delete={() => handleClickRemove()}
                     edit={() => handleClickEdit()}
                  >
                     <p className="card-content-title">{license.ownerUnit?.name}</p>
                     <p className="card-content">Administrador: {license.isAdmin ? "Sim" : "Não"}</p>
                     <p className="card-content">Matrícula: {license.enrollmentNumber}</p>
                     <p className="card-content">Unidade: {license.unit?.name}</p>
                  </Card>
               ))
            ) : (
               <div
                  style={{
                     marginTop: "10px",
                     backgroundColor: "var(--textColor)",
                     padding: "10px",
                     textAlign: "center",
                  }}
               >
                  Nenhum registro encontrado.
               </div>
            )}
         </div>
         <ModalComponent
            modalIsOpen={showModal}
            handleConfirm={() => handleClickModalButton("confirm")}
            handleCancel={() => handleClickModalButton("cancel")}
            modalText={mode === "add" ? "Vincular licença ao usuário" : "Editar vínculo do usuário com a licença"}
            buttonLabel1={"Confirmar"}
         >
            <div className="w-[720px] max-w-dvw flex flex-col gap-3">
               <LicenseUnitSelector
                  label={`Licença`}
                  unitId={ownerUnit?.id}
                  setUnitId={id => {
                     setOwnerUnit(condominiums.find(unit => unit.id === id));
                     setLicense(clientLicenses.find(l => Number(l.id_condominium) === Number(id)));
                     if (id !== ownerUnit?.id) {
                        setUnit(null);
                     }
                  }}
                  type={props.formMode}
               />
               <Input
                  name="enrollmentNumber"
                  id="enrollmentNumber"
                  labelText="Matrícula"
                  value={enrollmentNumber}
                  onChange={({ target }) =>
                     setEnrollmentNumber(target.value)
                  }
                  disabled={props.type === "consulta"}
                  required={false}
                  tooltipText="Código de registro de funcionário do condomínio."
                  tooltipVisible={true}
               />
               <div className="w-full mt-1.5!">
                  <ToggleButton
                     label="Administrador (Biometria)"
                     defaultChecked={isAdmin}
                     onChange={({ target }) => setIsAdmin(target.checked)}
                     required={false}
                     disabled={props.type === "consulta"}
                     tooltipText={
                        "Os dispositivos de biometria, que possuírem a função de administrador, receberão este usuário como administrador."
                     }
                     tooltipVisible={true}
                  />
               </div>
               <div className="modal-tabs mt-2! mb-1.5!" style={{ gap: 25 }}>
                  <AnimatedTabbar
                     value={activeTab}
                     onChange={setActiveTab}
                  >
                     <AnimatedTabbarItem name="perfil">
                        <IdCardLanyard size={18} className='inline-flex mr-0.5!' />
                        Perfil
                     </AnimatedTabbarItem>
                     <AnimatedTabbarItem name="unidade">
                        <Home size={18} className='inline-flex mr-0.5!' />
                        Unidade
                     </AnimatedTabbarItem>
                     <AnimatedTabbarItem name="avancado">
                        <LuSettings size={18} className='inline-flex mr-0.5!' />
                        Avançado
                     </AnimatedTabbarItem>
                  </AnimatedTabbar>
               </div>
               {activeTab === 'perfil' && (
                  <div className="w-full">
                     <div className="w-full! flex flex-col justify-between items-center mb-2!">
                        {/* <label htmlFor="select-unit-button" className="block w-full text-sm! text-left text-(--textColor) mb-1!">
                           Perfil
                        </label> */}
                        {ownerUnit && (
                           <div className="relative w-full flex flex-col gap-2 box-border!">
                              <div className="flex flex-row items-center gap-5 border! border-(--borderColor)! rounded-lg p-3.5!">
                                 <button
                                    type="button"
                                    onClick={() => setModalProfileIsOpen(true)}
                                    className="w-full flex flex-row items-center justify-between gap-3 rounded-lg"
                                 >
                                    {!profileTag ? (
                                       <>
                                          <div className="flex flex-row items-center gap-3">
                                             <div className="size-[50px] rounded-full border-2! border-(--primaryColor)! border-dashed!"></div>
                                             <h3 className="text-sm! opacity-60">Nenhum perfil selecionado</h3>
                                          </div>
                                       </>
                                    ) : (
                                       <>
                                          <div className="flex flex-row items-center gap-3" style={{ '--tagColor': profileTag?.color }}>
                                             <div className="relative flex items-center justify-center size-[54px] rounded-full">
                                                <span className="absolute size-full opacity-15 bg-(--tagColor) rounded-full z-10"></span>
                                                <DynamicIcon iconName={profileTag?.icon} size={30} color={profileTag?.color} className="relative z-20" />
                                             </div>
                                             <div className="flex flex-col justify-center gap-2! flex-1">
                                                <h3 className="font-bold text-left w-full text-[15px]!">
                                                   <span className="opacity-80">{profileTag?.name}</span>
                                                </h3>
                                             </div>
                                          </div>
                                       </>
                                    )}
                                    <BiCollapseAlt />
                                 </button>
                                 {profileTag && (
                                    <Button
                                       className="button-red"
                                       label={t("common.remove")}
                                       onClick={handleUnlinkProfile}
                                    />
                                 )}
                              </div>
                              {profileTag && profileTag.schema?.length > 0 && (
                                 <div className={`grid grid-cols-2 gap-4 w-full mt-3! px-1.5! mb-2.5! box-border!`}>
                                    <DynamicTagFields
                                       tag={profileTag}
                                       metadata={metadata}
                                       setMetadata={setMetadata}
                                       withWrapper={false}
                                    />
                                 </div>
                              )}
                           </div>
                        )}
                     </div>
                     {!ownerUnit && (
                        <p className="text-sm! text-left text-(--textColor) mb-1! opacity-40">Selecione uma licença para vincular um perfil.</p>
                     )}
                  </div>
               )}
               {activeTab === 'unidade' && (
                  <div className="w-full mt-1!">
                     <div className="w-full! flex flex-col justify-between items-center mb-2!">
                        {/* <label htmlFor="select-unit-button" className="block w-full text-sm! text-left text-(--textColor) mb-1!">
                           Unidade
                        </label> */}
                        {ownerUnit && (
                           <div className="relative w-full flex flex-col gap-2 box-border!">
                              <div className="flex flex-row items-center gap-5 border! border-(--borderColor)! rounded-lg p-3.5!">
                                 <button
                                    type="button"
                                    onClick={() => setModalUnitIsOpen(true)}
                                    className="w-full flex flex-row items-center justify-between gap-3 rounded-lg"
                                 >
                                    {!unit ? (
                                       <>
                                          <div className="flex flex-row items-center gap-3">
                                             <div className="size-[50px] rounded-full border-2! border-(--primaryColor)! border-dashed!"></div>
                                             <h3 className="text-sm! opacity-60">{t("monitoring.noUnitSelected")}</h3>
                                          </div>
                                       </>
                                    ) : (
                                       <>
                                          <div className="flex flex-row items-center gap-3" style={{ '--tagColor': unitTag?.color }}>
                                             <div className="relative flex items-center justify-center size-[54px] rounded-full">
                                                <span className="absolute size-full opacity-15 bg-(--tagColor) rounded-full z-10"></span>
                                                <DynamicIcon iconName={unitTag?.icon} size={30} color={unitTag?.color} className="relative z-20" />
                                             </div>
                                             <div className="flex flex-col justify-center gap-2! flex-1">
                                                <h3 className="font-bold text-left w-full text-[15px]!">
                                                   <span className="opacity-80">{unitTag?.name}:</span>
                                                   {' '}
                                                   {unit.name}
                                                </h3>
                                                <div className="flex flex-row items-center">
                                                   <span className="text-xs! opacity-80 mr-3.5!">
                                                      <strong className="opacity-65">Nº de Vagas:</strong> {unit.parkingLotQuantity}
                                                   </span>
                                                   <span className="text-xs! opacity-80">
                                                      <strong className="opacity-65">Vagas Ocupadas:</strong>{" "}
                                                      {unit.parkingLotBusy}
                                                   </span>
                                                </div>
                                             </div>
                                          </div>
                                       </>
                                    )}
                                    <BiCollapseAlt />
                                 </button>
                                 {unit && (
                                    <Button
                                       className="button-red"
                                       label="Remover"
                                       onClick={handleUnlinkUnit}
                                    />
                                 )}
                              </div>
                              {unit && (
                                 <div className={`grid grid-cols-2 gap-4 w-full mt-3! mb-2.5! px-1.5! box-border!`}>
                                    <Select
                                       labelText={t("common.responsibility")}
                                       value={`${responsibility}`}
                                       onChange={({ target }) => {
                                          setResponsibility(target.value)
                                       }}
                                       disabled={props.formMode === "consulta"}
                                       required={false}
                                       options={Object.entries(UnitResponsibilityText).map(([key, value]) => ({
                                          value: key,
                                          text: t(value),
                                       }))}
                                    />
                                    {responsibility !== `${UnitResponsibility.RESPONSIBLE}` && (
                                       <div className="w-full">
                                          <Select
                                             labelText={t("monitoring.relationWithResponsible")}
                                             value={relation}
                                             onChange={({ target }) => {
                                                setRelation(target.value)
                                             }}
                                             disabled={props.formMode === "consulta"}
                                             required={false}
                                             options={Object.entries(UnitResponsibleRelationText).map(([key, value]) => ({
                                                value: key,
                                                text: t(value),
                                             }))}
                                          />
                                       </div>
                                    )}
                                    {responsibility !== `${UnitResponsibility.RESPONSIBLE}` && relation === `${UnitResponsibleRelation.OTHER}` && (
                                       <div className="w-full">
                                          <Input
                                             labelText={t("monitoring.otherRelationWithResponsibleQuestion")}
                                             value={otherRelation}
                                             onChange={({ target }) => {
                                                setOtherRelation(target.value)
                                             }}
                                             disabled={props.formMode === "consulta"}
                                             required={true}
                                             type="text"
                                          />
                                       </div>
                                    )}
                                 </div>
                              )}
                           </div>
                        )}
                     </div>
                     {!ownerUnit && (
                        <p className="text-sm! text-left text-(--textColor) mb-1! opacity-40">Selecione uma licença para vincular uma unidade.</p>
                     )}
                  </div>
               )}
               {activeTab === 'avancado' && (
                  <>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6! mt-2">
                        {responsibility === `${UnitResponsibility.NEEDS_AUTHORIZATION}` && (
                           <div className="responsibles-container col-span-2 flex flex-col items-center justify-between">
                              <div className="flex justify-between items-center mb-1! w-full">
                                 <h4 className="input-label">Unidades autorizadoras</h4>
                                 <div className="flex items-center gap-5">
                                    {authorizerUnits && authorizerUnits.length > 1 && (
                                       <Button
                                          label="Limpar"
                                          action="delete"
                                          onClick={() => setAuthorizerUnits([])}
                                          className="button-link text-red-400!"
                                       />
                                    )}
                                    <Button
                                       label="Adicionar"
                                       action="add"
                                       onClick={() => setModalAuthorizerUnitIsOpen(true)}
                                       className="button-link"
                                    />
                                 </div>
                              </div>
                              <div className="w-full flex gap-2 flex-wrap mt-2!">
                                 {!authorizerUnits || authorizerUnits.length === 0 ? (
                                    <p className="w-full text-sm! text-left! text-(--textColor) mb-1! opacity-40">Nenhuma unidade autorizadora.</p>
                                 ) : (
                                    <>
                                       {authorizerUnits.map((unit) => (
                                          <div key={unit.id} className="flex items-center gap-2 bg-(--borderColor) px-2! py-1! rounded-sm">
                                             <span className="text-[18px]">{unit.name}</span>
                                             <Button
                                                label="Remover"
                                                action="remove"
                                                onClick={() => handleUnlinkAuthorizerUnit(unit)}
                                                className="button-link"
                                             />
                                          </div>
                                       ))}
                                    </>
                                 )}
                              </div>
                           </div>
                        )}
                        <div className="col-span-2 flex items-center justify-between">
                           <div className="grid grid-cols-2 gap-3 w-full">
                              <div className="flex items-center">
                                 <Input
                                    labelText="Créditos"
                                    value={credits}
                                    onChange={({ target }) => {
                                       setCredits(target.value);
                                    }}
                                    disabled={props.formMode === "consulta" || disabledCredits}
                                    required={true}
                                    type="number"
                                 />
                              </div>
                              <div className="flex items-center pt-4!">
                                 <ToggleButton
                                    label="Desabilitar créditos"
                                    defaultChecked={disabledCredits}
                                    onChange={({ target }) => setDisabledCredits(target.checked)}
                                    required={false}
                                    disabled={props.type === "consulta"}
                                    tooltipText={
                                       "Desabilita a verificação dos créditos do usuário na licença."
                                    }
                                    tooltipVisible={true}
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                  </>
               )}
            </div>
         </ModalComponent>
         <ModalComponent
            modalIsOpen={modalAuthorizerUnitIsOpen}
            modalText={"Selecione a unidade autorizadora"}
            handleConfirm={handleConfirmAuthorizerUnit}
            handleCancel={handleCancelAuthorizerUnit}
         >
            <div className="tab-units-search-container">
               <Input
                  value={customInput1}
                  type="text"
                  placeholder="Buscar"
                  onChange={({ target }) => setCustomInput1(target.value)}
                  onKeyPress={(e) => e.key === "Enter" && setFilters([customInput1])}
                  className="search-input input-form"
               />
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
               <div style={{ width: "420px", height: "fit-content" }}>
                  <ListUnits
                     showSelectedIcon={true}
                     showTags={true}
                     filters={filters}
                     linkableToUser={true}
                     smallList={true}
                     unitId={ownerUnit?.id}
                  />
               </div>
            </div>
         </ModalComponent>
         <ModalComponent
            modalIsOpen={modalUnitIsOpen}
            modalText={"Selecione a unidade"}
            handleConfirm={handleConfirm}
            handleCancel={handleCancel}
         >
            <div className="tab-units-search-container">
               <Input
                  value={customInput1}
                  type="text"
                  placeholder="Buscar"
                  onChange={({ target }) => setCustomInput1(target.value)}
                  onKeyPress={(e) => e.key === "Enter" && setFilters([customInput1])}
                  className="search-input input-form"
               />
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
               <div style={{ width: "420px", height: "fit-content" }}>
                  <ListUnits
                     showSelectedIcon={true}
                     showTags={true}
                     filters={filters}
                     linkableToUser={true}
                     smallList={true}
                     unitId={ownerUnit?.id}
                  />
               </div>
            </div>
         </ModalComponent>
         <ModalComponent
            modalIsOpen={modalProfileIsOpen}
            modalText={"Selecione o perfil"}
            handleConfirm={handleConfirmProfile}
            handleCancel={handleCancelProfile}
         >
            <div className="tab-units-search-container">
               <Input
                  value={searchProfileTag}
                  type="text"
                  placeholder="Buscar"
                  onChange={({ target }) => setSearchProfileTag(target.value)}
                  onKeyPress={(e) => e.key === "Enter" && setFiltersProfileTag([searchProfileTag])}
                  className="search-input input-form"
               />
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
               <div style={{ width: "420px", height: "fit-content" }}>
                  <ListClientTags
                     showSelectedIcon={true}
                     showTags={true}
                     search={searchProfileTag}
                     smallList={true}
                     filters={{ licensePerson: true }}
                  />
               </div>
            </div>
         </ModalComponent>
      </div>
   );
};

export default TabCondoUserUnits;
